import { useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import { navActionAtom } from '../store';

/**
 * Registers what the nav's "+" does while the calling page is mounted
 * (Living Room: new chat on Chats, upload on Documents, new list on Lists).
 */
export function useNavAction(label: string | null, onSelect: () => void) {
  const setAction = useSetAtom(navActionAtom);
  // The latest handler without re-registering on every render.
  const handler = useRef(onSelect);
  handler.current = onSelect;

  useEffect(() => {
    if (!label) {
      setAction(null);
      return;
    }
    setAction({ label, onSelect: () => handler.current() });
    return () => setAction(null);
  }, [label, setAction]);
}
